import { CAMPAIGN_TYPES } from '../../pages/Campaigns/constants/campaign-types';

export default {
  paginatedJoynMessageCampaigns: {},
  campaign: {
    type: CAMPAIGN_TYPES.MESSAGE.key,
  },
};
